export default __webpack_public_path__ + "static/media/bannerHome.8cb4c61e.png";